import React, { Suspense } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Switch, Route } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import Layout from "./layout";
import routePaths from "./routePaths";
import CircularSpinner from "shared/CircularSpinner";
const FormsModule = React.lazy(() =>
	import("modules/FormsModule/index.module.js")
);
const DemoForms = React.lazy(() =>
	import("./library/OnboardingForms/index.demo")
);
const ErrorPage = React.lazy(() => import("modules/ErrorPage"));

export const routesPath = routePaths;

const RouteWrapper = props => {
	//add auth validation here
	return <Route {...props} />;
};

RouteWrapper.propTypes = {
	userInfo: PropTypes.object,
	routesPath: PropTypes.object,
	protect: PropTypes.string
};

class RouterComponent extends React.Component {
	render() {
		return (
			<ConnectedRouter history={this.props.history}>
				<div>
					<Switch>
						<Layout>
							<Suspense fallback={loader()}>
								<Switch>
									<Route
										path={routesPath.demoformsPage}
										component={DemoForms}
										exact
									/>
									<RouteWrapper
										exact
										path={routesPath.formsPage}
										component={FormsModule}
										userInfo={this.props.userInfo}
									/>
									<RouteWrapper
										component={ErrorPage}
										userInfo={this.props.userInfo}
									/>
								</Switch>
							</Suspense>
						</Layout>
					</Switch>
				</div>
			</ConnectedRouter>
		);
	}
}

RouterComponent.propTypes = {
	router: PropTypes.object,
	history: PropTypes.object,
	userInfo: PropTypes.object
};

function mapStateToProps(state, props) {
	return {
		router: state.router,
		history: props.history,
		userInfo: state.userInfo
	};
}

const loader = () => {
	return (
		<div
			style={{
				position: "absolute",
				top: "50%",
				left: "50%",
				opacity: "0.2"
			}}
		>
			<CircularSpinner strokeColor="#1a1a1a" fillColor="none" />
		</div>
	);
};

export default connect(mapStateToProps)(RouterComponent);
